import { useUIStore } from '../store/ui';

export const useUI = () => {
  const {
    errorModal,
    showError,
    hideError,
    loadingCount,
    showLoading,
    hideLoading,
    changeTargetMsisdnOpen,
    showChangeTargetMsisdn,
    hideChangeTargetMsisdn,
  } = useUIStore();

  return {
    errorModal,
    showError,
    hideError,
    loadingCount,
    showLoading,
    hideLoading,
    changeTargetMsisdnOpen,
    showChangeTargetMsisdn,
    hideChangeTargetMsisdn,
  };
};
